export default __webpack_public_path__ + "locales/si/FormGallery.json?hash=ce78e2f3279191ad9ebd3e9d8edd49e5";